import styled, { css } from 'styled-components';

import LoaderSVG from 'ui/assets/img/F2m-loader.svg';
import LoaderSVGReverse from 'ui/assets/img/F2m-loader_reverse.svg';
import { pxToRem } from 'utils/scss';

export const SpinnerWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  border-radius: ${pxToRem('8px')};

  ${props =>
    !props.isOnChangePassword &&
    css`
      min-height: ${pxToRem('400px')};
    `}
`;

export const SpinnerLoader = styled.div`
  position: absolute;
  display: block;
  top: 50%;
  left: 50%;
  width: 8em;
  height: 8em;
  margin-top: -4.05em;
  margin-left: -4em;
  font-size: ${pxToRem('10px')};
  background: url(${props => (props.reverse ? LoaderSVGReverse : LoaderSVG)});
  background-repeat: no-repeat;
  height: 100%;
`;

export const SpinnerExternalWrapper = styled.div`
  position: relative;
  width: inherit;
  height: 300px;
`;
